import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function TrendingVideos() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);
  const newVideos = videos.filter((v) => v.isNew && !v.isHot).slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/yingshiju"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-12">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-1">
              最新上线
            </h3>
            <p className="text-sm text-foreground-600">新鲜出炉的优质视频</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {[...newVideos, ...videos.filter((v) => !v.isHot && !v.isNew).slice(0, 4 - newVideos.length)].slice(0, 4).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/yingshiju"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}